export default "__VITE_ASSET__BIBFKuKP__"